export const invoiceTypes = [
  "SPECIFICATION",
  "SPECIFICATION_T1",
  "INVOICE_EPI",
  "ACT_EPI",
  "ACT_EPI_BYN",
  "INVOICE_WARRANTY",
  "ACT_WARRANTY_BYN",
  "ACT_WARRANTY",
  "REREGISTRATION_EPI",
  "REREGISTRATION_CERTIFICATE",
  "ACT_WARRANTY_T1_BYN",
  "ACT_WARRANTY_T1",
  "INVOICE_T1",
] as const;
export type InvoiceType = typeof invoiceTypes[number];